<template>
  <span class="font-red" style="margin-right: 5px">{{ showAuditTime }}</span>
</template>

<script>
export default {
  name: "CountDown2",
  props: {
    payLeftTime: Number,
  },
  data() {
    return {
      showAuditTime: "00:00",
    };
  },
  mounted() {
    this.payLeftTime && this.countDown2(this.payLeftTime);
  },
  methods: {
    countDown2(timer) {
      if (!timer) {
        return;
      }
      const _time = new Date(timer) - new Date();
      let count = parseInt(_time / 1000);
      var clearInterval = window.setInterval(() => {
        if (count <= 0) {
          window.clearInterval(clearInterval);
          this.$emit("cb");
          return;
        }
        let hh = Math.floor((count / 60 / 60));
        let mm = Math.floor((count / 60) % 60);
        let ss = Math.floor(count % 60);
        hh = hh < 10 ? '0' + hh : hh;
        mm = mm < 10 ? '0' + mm : mm;
        ss = ss < 10 ? '0' + ss : ss;
        this.showAuditTime = hh + ':' + mm + ':' + ss;
        // const minute =
        //   count > 0
        //     ? parseInt(count / 60) > 9
        //       ? parseInt(count / 60)
        //       : "0" + parseInt(count / 60)
        //     : "00";
        // const second =
        //   count > 0
        //     ? parseInt(count % 60) > 9
        //       ? parseInt(count % 60)
        //       : "0" + parseInt(count % 60)
        //     : "00";
        // const hour =
        //   minute / 60 > 1
        //     ? minute / 60 > 9
        //       ? minute / 60
        //       : `0${minute / 60}`
        //     : "";
        // this.showAuditTime =
        //   (hour !== "" ? hour + ":" : "") + minute + ":" + second;
        count--;
      }, 1000);
    },
  },
};
</script>